import { jsx as _jsx } from "react/jsx-runtime";
import { filterValue } from '../skyla/helpers';
export const NodeInputHidden = ({ attributes, }) => {
    // Render a hidden input field
    return (_jsx("input", { type: attributes.type, name: attributes.name, value: filterValue(attributes.value)?.toString() ?? 'true' }));
};
